module.exports = __webpack_public_path__ + "img/logo.bb84853c.png";